import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 新增分类
    add: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/category/saveCategory`, params),
    //查询分类列表
    get: params => request.get(`${base.baseUrl}/yyyhao-cloud-product/category/getCategoryList`, params),
    //修改分类
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/category/updateCategory`, params),
    //删除分类
    del: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/category/deleteCategory`, params),
}